export const MS_IN_S = 1000;
export const S_IN_M = 60;

export const DAY_NUMBERS = ['0', '1', '2', '3', '4', '5', '6'];

export const PING_THROTTLE_INTERVAL = 60 * MS_IN_S;
